module.exports = __webpack_public_path__ + "img/set_alpha_4.d406f9b6.png";